<template>
  <div class="html-stil">

      <div class="body-stil">

      <h1>Implikation och Ekvivalens</h1>

<h2><b>Sätt in rätt symbol ⇒, ⇐ eller ⇔ mellan påståendena</b></h2><br><br>

<div class="rad-container">
     I min triangel är två (men inte tre) vinklar lika stora. &nbsp;
     <div class="droptarget border" v-on:drop="drop" v-on:dragover="allowDrop">    </div>

     Min triangel är likbent. &nbsp;
</div>

<br>

<br>
<div class="rad-container">
    Det är mörkt ute i Lund. &nbsp;
    <div class="droptarget border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
    Det är midnatt i Lund.

</div>



<br>



<br>
<div class="rad-container">
    2x + 3 = 9 &nbsp; <div class="droptarget border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
    x = 3
</div>
<br>

<br>
<div class="rad-container">
    Förändringsfaktorn är 1,25 &nbsp;<div class="droptarget border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
    Det är en ökning med 25%
</div>
    <br><br>
<div class="rad-container">
    Figuren är en kvadrat &nbsp;
    <div class="droptarget border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
    Figuren har fyra sidor

</div>
<br>
<br><br>
<div class="rad-container">
    a * b = 6 &nbsp;
    <div class="droptarget border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
    a = 3 och b = 2
</div>

<br><br>

<div class="rad-container">
    Index för mobiltelefoner är 100 år 2015 &nbsp;
    <div class="droptarget border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
    2015 är ett basår för mobiltelefoner
</div>
    <br><br>

<div class="rad-container">
    Åsa är mer än 20 år &nbsp;
    <div class="droptarget border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
     Åsa är minst 20 år
</div>

<br><br>
<div class="rad-container">

    Nisse är sjuk &nbsp;
    <div class="droptarget border" v-on:drop="drop" v-on:dragover="allowDrop"></div>&nbsp;
    Nisse har covid 19
</div>

<br><br>

<div class="rad-container">
    Detta djur är en ko &nbsp;
    <div class="droptarget border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
    Detta djur har 4 ben
</div>

<br><br>

<div class="rad-container">
    Alla sidor i triangeln är lika långa &nbsp;
    <div class="droptarget border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
    Alla vinklar i triangeln är lika stora
</div>

<br><br>

<div class="rad-container">
    Kalle solar i trädgården &nbsp;
    <div class="droptarget border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
    Solen skiner i trädgården
</div>

<br><br><br><h2><b>Sätt sant eller falskt i rutorna</b></h2><br><br>



<div class="rad-container">
    x = 2 ⇔ 2x = 4 &nbsp;
    <div class="droptarget border" v-on:drop="drop" v-on:dragover="allowDrop"></div>

</div>

<br><br>

<div class="rad-container">
    x > 2 ⇒ x är positivt &nbsp;
    <div class="droptarget border" v-on:drop="drop" v-on:dragover="allowDrop"></div>

</div>

<br><br>

<div class="rad-container">
    x<sup>2</sup> = 9 ⇒ x = 3&nbsp;
    <div class="droptarget border" v-on:drop="drop" v-on:dragover="allowDrop"></div>

</div>


<br><br>

<div class="rad-container">
    x = 3 ⇒ x<sup>2</sup> = 9  &nbsp;
    <div class="droptarget border" v-on:drop="drop" v-on:dragover="allowDrop"></div>

</div>

<br><br>

<div class="rad-container">
    En lådas sidor är 4 cm, 5 cm och 10cm ⇔ Lådans volym är 200cm<sup>3</sup> &nbsp;
    <div class="droptarget border" v-on:drop="drop" v-on:dragover="allowDrop"></div>

</div>

<br><br>
<br><br>
<div><b>Följande implikation är sann:</b>
    Det juletider ⇒ Tomtefar jobbar hårt.<br><br>
    <b>Vilken eller vilka av följande implikationer är sanna?</b></div>
<br><br>


<div class="rad-container">
    Tomtefar jobbar hårt. ⇒ Det är juletider.  &nbsp;
    <div class="droptarget border" v-on:drop="drop" v-on:dragover="allowDrop"></div>

</div>
<br><br>
<div class="rad-container">
    Tomtefar slappar. ⇒ Det är inte juletider.  &nbsp;
    <div class="droptarget border" v-on:drop="drop" v-on:dragover="allowDrop"></div>

</div>
<br><br>
<div class="rad-container">
    Det är inte juletider. ⇒ Tomtefar slappar.&nbsp;
    <div class="droptarget border" v-on:drop="drop" v-on:dragover="allowDrop"></div>

</div>




<div class="bildlada">
<img src="../assets/Young_frege.jpg" alt="bild på ung Gottlob Frege">
<div class="bildtext"><a href="https://sv.wikipedia.org/wiki/Gottlob_Frege">    Gottlob Frege - "logikens fader" </a>  </div>
</div>


<div class="titellada">
    <div class="inner-titellada">

<div class="startplats">
    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">
        <div class="y r" v-on:dragstart="dragStart"   draggable="true" id="y1">⇒</div>
    </div>
</div>
<br>
<div class="startplats">
    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y r" v-on:dragstart="dragStart"  draggable="true" id="y2">⇐</div>
    </div>
    </div>
<br>
<div class="startplats">
    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y r" v-on:dragstart="dragStart"  draggable="true" id="y3">⇔</div>
    </div>
    </div>
<br>
<div class="startplats">
    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y r" v-on:dragstart="dragStart"  draggable="true" id="y4">⇒</div>
    </div>
    </div>
<br>
<div class="startplats">
    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y r" v-on:dragstart="dragStart"  draggable="true" id="y5">⇐</div>
    </div>
    </div>
<br>
<div class="startplats">
    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y r" v-on:dragstart="dragStart"  draggable="true" id="y6">⇔</div>
    </div>
    </div>
<br><div class="startplats">
    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y r" v-on:dragstart="dragStart"  draggable="true" id="y7">⇒</div>
    </div>
    </div>
<br><div class="startplats">
    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y r" v-on:dragstart="dragStart"  draggable="true" id="y8">⇐</div>
    </div>
    </div>
<br><div class="startplats">
    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y r" v-on:dragstart="dragStart"  draggable="true" id="y9">⇔</div>
    </div>
    </div>
<br><div class="startplats">


    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y r" v-on:dragstart="dragStart"  draggable="true" id="y10">⇒</div>
    </div>
    </div>
<br><div class="startplats">
    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y r" v-on:dragstart="dragStart"  draggable="true" id="y11">⇐</div>
    </div>
    </div>
<br>
<div class="startplats">

    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y r" v-on:dragstart="dragStart"  draggable="true" id="y12">⇔</div>
    </div>
    </div>
<br>

<div class="startplats">

    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y r" v-on:dragstart="dragStart"  draggable="true" id="y13">Sant</div>
    </div>
    </div>
<br>

<div class="startplats">

    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y r" v-on:dragstart="dragStart"  draggable="true" id="y14">Falskt</div>
    </div>
    </div>
<br>

<div class="startplats">

    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y r" v-on:dragstart="dragStart"  draggable="true" id="y15">Sant</div>
    </div>
    </div>
<br>

<div class="startplats">

    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y r" v-on:dragstart="dragStart"  draggable="true" id="y16">Falskt</div>
    </div>
    </div>
<br>

<div class="startplats">

    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y r" v-on:dragstart="dragStart"  draggable="true" id="y17">Sant</div>
    </div>
    </div>
<br>

<div class="startplats">

    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y r" v-on:dragstart="dragStart"  draggable="true" id="y18">Falskt</div>
    </div>
    </div>
<br>

<div class="startplats">

    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y r" v-on:dragstart="dragStart"  draggable="true" id="y19">Sant</div>
    </div>
    </div>
<br>

<div class="startplats">

    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y r" v-on:dragstart="dragStart"  draggable="true" id="y20">Falskt</div>
    </div>
    </div>
<br>


</div>
</div>

<br><br><br><br>

<div class="kontrollknapp" v-on:click="allaRätt()">
    Fick jag alla rätt?
</div>

<br>
<div class="m" id="rätt">
<br>Alla rätt. Bra jobbat! Kodord:------- NOSHÖRNING
</div>

<div class="m" id="fel">
<br>Du fick inte alla rätt. Försök igen!
</div>


<br><br><br>

<div class="info">

<!--br><i>Övning av Bo Silborn, Polhemskolan
<br>Modifiering och digitalisering av Klas Wärnå, Polhemskolan
<br><br>

</i-->

</div>
</div>
</div>
</template>

<script>
export default {
  name: 'Logik',
  title () {
   return `Logik`
 },
  props: {
    msg: String
},
data() {
    return {
        rättaSvar: ["⇔", "⇐", "⇔", "⇔", "⇒", "⇐", "⇐",
            "⇒", "⇐", "⇒", "⇔", "⇒",
        "Sant","Sant","Falskt","Sant","Falskt","Falskt","Sant","Falskt"],
        title: "Logik"
    }
},
methods: {
    dragStart:function(event) {
        event.dataTransfer.setData("Text", event.target.id);
  },

    /*dragging: function(event) {
        console.log("nu dragging" + event);
  },*/

     allowDrop:function(event) {
      event.preventDefault();
  },

    drop:function(event) {
      event.preventDefault();
      var data = event.dataTransfer.getData("Text");

      event.target.appendChild(document.getElementById(data));

  },

    allaRätt:function() {
    var lista = document.getElementsByClassName('r');
    var lista2 = document.getElementsByClassName('rad-container');

        var lyckades = true;

        var längd = lista.length;

        for (var i=0; i<längd; i++) {
            if (lista[i].textContent != this.rättaSvar[i]) {

              lista2[i].style.color="red";
                lyckades = false;
            } else {
              lista2[i].style.color="black";
            }
        }

        this.testresultat(lyckades);
        var that = this;
        setTimeout(function() {
            that.osynliggör()
        }, 3000);
    },

    testresultat: function(meddelande) {
        if (meddelande) {
            document.getElementById('rätt').style.display="block";
        } else {
            document.getElementById('fel').style.display="block";
        }
    },

    osynliggör: function() {
    document.getElementById('fel').style.display="none";
    document.getElementById('rätt').style.display="none";
    }



    },
    beforeCreate: function() {
        document.title = "Implikation och Ekvivalens";

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.html-stil {
    background-color: lightblue;
    padding-bottom: 10px;
    padding-top: 20px;


}
.body-stil {
  background-color: lightgrey;
  margin-left: 20%;
  margin-right: 20%;

  padding-left:2em;
  padding-right:2em;
  padding-top: 0.5em;
  /*border-radius: 10px;*/
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  font-family: sans-serif;
  margin-bottom: 10px;
  text-align: left;
}

h1 {
    /*background-color: #7030a0;*/
    background-color: #455;
    color: white;
    font-family: sans-serif;
    padding-top:30px;
    padding-bottom:30px;
    padding-left:5px;
    text-align: center;
}





/*fixar vit bakgrundsfärg*/
.y {
    display: inline-block;
    color: white;
    width:100%;
    text-align: center;
    line-height: 2em;

}

.startplats {
/*    height:1.6em;*/
}


.rad-container {
    display: block;
    color: black;
    font-family: sans-serif;
    /*height: 2em;*/
    height: 100%;


}


/*Lådan som orden läggs i. I texten*/
.droptarget {
    position: relative;
    display: inline-block;
    width: 5.5em;
    /*height: 2em;*/
    height: 2em;
    margin-bottom: -12px;
}

.border {
    border: solid 1px;
}



/*röd*/
#y55 {
    background-color: #c00000;
}







#y1 {
    background-color: #cc00cc;
}

#y2 {
    background-color: #7030a0;
}

#y3 {
    background-color: #ed7d31;
}


#y4 {
    background-color: #cc00cc;
}

#y5 {
    background-color: #7030a0;
}

#y6 {
    background-color: #ed7d31;
}

#y7 {
    background-color: #cc00cc;
}

#y8 {
    background-color: #7030a0;
}

#y9 {
    background-color: #ed7d31;
}
#y10 {
    background-color: #cc00cc;
}

#y11 {
    background-color: #7030a0;
}

#y12 {
    background-color: #ed7d31;
}
#y13 {
    background-color: #4caf50;
}

#y14 {
    background-color: #c00000;
}

#y15 {
    background-color: #4caf50;
}

#y16 {
    background-color: #c00000;
}

#y17 {
    background-color: #4caf50;
}

#y18 {
    background-color: #c00000;
}

#y19 {
    background-color: #4caf50;
}
#y20 {
    background-color: #c00000;
}


.info {
    font-family: serif;
    font-size: 0.8em;
}

.inner-titellada {
    overflow-y:auto;
    height: 100%;
}

.titellada {
    padding:0.5em;
    width: 200px;
    /*height: 88vh;*/
    height: calc(100% - 106px);
    position: fixed;
    background-color: lightgrey;
    display: block;
    top: 20px;
    right: 10px;
    font-family: sans-serif;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.bildlada {
    padding:0.5em;
    width: 200px;
    /*height: 100px;*/
    position: fixed;
    background-color: lightgrey;
    display: block;
    top: 20px;
    left: 10px;
    font-family: sans-serif;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.kontrollknapp {
    background-color: darkgreen;

    border-style: solid;
    border-width:thin;
    padding: 10px;
    display: inline;
    color: white;
}

.kontrollknapp:hover {
    background-color: #090;
}

img {

    width: 200px;
    height: auto;
}

.bildtext {
    font-size: 0.75em;
}

.m {
    font-size: 2em;
}

#rätt {
    display: none;
    color: green;
}


#fel {
    display: none;
    color: red;

}
</style>
